import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, Input, Output, output, EventEmitter } from '@angular/core';
import { BaseLevelComponent } from '../_base/base-level.component';
import { MenuGroup } from '../../models/menu-group';
import { MenuLink, CustomMenuLink } from '../../models/menu-link';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap/tooltip';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush, //OBS! OnPush
    selector: 'largeMenu-twoLevel',
    templateUrl: './two-level.component.html',
    styleUrls: ['../_scss/level.component.scss'],
    host: { 'cid': 'Level2' },
    imports: [NgbTooltip]
})
export class TwoLevelComponent 
    extends BaseLevelComponent 
    implements OnInit {

    @Input() declare showMenu: boolean;
    @Input() declare menuGroups: MenuGroup[];
    @Input() customMenuLinks: CustomMenuLink[];
    @Input() firstLevelMenuLinks: MenuLink[];

    @Output() goToLink = new EventEmitter();
    public menuWasHidden = output();

    constructor(
        ref: ChangeDetectorRef
    ) { 
        super(ref);
    }

    ngOnInit(): void {
        window.onclick = (event: any) => {
            let closed = super.closeMenuWhenClickingElsewhere(event);
            if (closed) this.menuWasHidden.emit();
        }
    }

    public goTo(link: MenuLink) {
        if (link) {
            this.goToLink.emit(link);
            super.toggleMenu();
        }
    }

    public customLinkClicked(menuLink: CustomMenuLink) {
        if (menuLink.isExternalLink)
            location.href = menuLink.link;
        else
            this.goTo(new MenuLink('customLink', menuLink.name, '', menuLink.link));
    }
}
